// lib/cn.js
/**
 * Utility pour combiner des classNames conditionnels
 * Alternative légère à clsx/classnames
 */

export function cn(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default cn
